import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-title',
  templateUrl: 'component-title.component.html'
})
export class ComponentTitleComponent {
  @Input() setting: any;
}
